export const LOADING_STATUS = "LOADING_STATUS";
export const SAVE_LOADING_STATUS = "SAVE_LOADING_STATUS";
export const GET_STATUS = "GET_STATUS";
export const FORM_FAIL = "FORM_FAIL";
export const STATUS_FAIL = "STATUS_FAIL";
export const LOADING_STATUS_BY_ID = "LOADING_STATUS_BY_ID";
export const GET_STATUS_BY_ID = "GET_STATUS_BY_ID";